module.exports = __webpack_public_path__ + "img/fi-rr-cloud-disabled.1cfaae48.svg";